import type { AppKey } from './apps';
import hub from './icons/apps/hub.svg?raw';
import ezy from './icons/apps/ezy.svg?raw';
import box from './icons/apps/box.svg?raw';
import hei from './icons/apps/hei.svg?raw';
import mee from './icons/apps/mee.svg?raw';
import edu from './icons/apps/edu.svg?raw';
import mov from './icons/apps/mov.svg?raw';
import kit from './icons/apps/kit.svg?raw';
import ask from './icons/apps/ask.svg?raw';

// SVG icon app lấy nguyên từ canvas Mint (Hub = logo HANA, Box Hana Blue, Hei xanh lá dịu, Ezy = mũi tàu nền xanh đậm, Kit = cú lục giác nền slate).
const SVG: Record<AppKey, string> = { hub, ezy, box, hei, mee, edu, mov, kit, ask };

export function AppIcon({ app, size = 40 }: { app: AppKey; size?: number }) {
  return (
    <span
      className="hana-appicon"
      aria-hidden="true"
      style={{ width: size, height: size, display: 'flex', flexShrink: 0 }}
      dangerouslySetInnerHTML={{ __html: SVG[app] }}
    />
  );
}
